module.exports = __webpack_public_path__ + "static/media/ors.9c7cf06a.png";